'use client';

import * as React from 'react';
export interface FilterButtonProps {
  label: string;
  isActive?: boolean;
  onClick: () => void;
}
export function FilterButton({
  label,
  isActive,
  onClick
}: FilterButtonProps) {
  return <button type="button" onClick={onClick} className={`rounded-[100px] px-4 py-1 text-center text-sm font-medium tracking-normal ${isActive ? 'bg-x-primary-2  text-white' : 'border border-solid border-black/10 bg-x-grey-back text-x-secondary'}`} data-sentry-component="FilterButton" data-sentry-source-file="filter-button.tsx">
      {label}
    </button>;
}
;